<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">
          {{ pageTitle }}
        </div>
        <div>
          <bread-crumb :bread-crumbs="['Agent Summary']" />
        </div>
      </v-card-title>

      <v-data-table
        fixed-header
        height="55vh"
        :headers="dessertHeaders"
        :items="partnerSummary"
        :search="search"
        dense
        item-key="name"
        show-group-by
        group-by="partner_type_data.value"
      >
        <template v-slot:group.header="{ group, headers, toggle }">
          <td :colspan="headers.length" @click="toggle">
            <!-- <v-btn @click="toggle" x-small icon :ref="group">
              <v-icon v-if="isOpen">mdi-plus</v-icon>
              <v-icon v-else>mdi-minus</v-icon>
            </v-btn> -->
            <span class="mx-5 font-weight-bold">{{ group }}</span>
          </td>
        </template>
        <template v-slot:item.Bank="{ item }">
          <a
            class="text-decoration-underline"
            @click="bankPage()"
            :title="item.Bank"
          >
            {{ item.Bank }}
          </a>
        </template>
        <template v-slot:item.contact_person="{ item }">
          <span class="font-weight-bold">{{ item.contact_person }}</span>
          <p class="pa-0 ma-0">{{ item.contact_person_email }}</p>
        </template>
        <template v-slot:item.Branch="{ item }">
          <a
            class="text-decoration-underline"
            @click="Branchname()"
            :title="item.Branch"
          >
            {{ item.Branch }}
          </a>
        </template>
        <template v-slot:item.Commission="{ item }">
          <a
            class="text-decoration-underline"
            @click="Payoutcommission()"
            :title="item.Commission"
          >
            {{ item.Commission }}
          </a>
        </template>
        <template v-slot:item.partner_name="{ item }">
          <a
            class="border-b"
            @click="
              $router.push({
                name: 'Create Agent',
                query: {
                  parent_partner_id: parent_partner_id,
                  partner_id: item.partner_id,
                  partner_type_code: $route.query.partner_type_code,
                },
              })
            "
            >{{ item.partner_name }}</a
          >
        </template>
        <template v-slot:item.status="{ item }">
          <v-btn
            depressed
            x-small
            @click="openBlockDialog(item)"
            color="success"
            :title="`Block ${entityLabel}`"
            class="text-capitalize"
            v-if="item.status"
          >
            Active
          </v-btn>
          <v-btn
            depressed
            x-small
            @click="openBlockDialog(item)"
            color="warning"
            class="text-capitalize"
            :title="`Unblock ${entityLabel}`"
            v-else
          >
            Block
          </v-btn>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-icon
              small
              title="Users List"
              color="info"
              class="mr-2"
              @click="
                $router.push({
                  name: 'User Summary',
                  query: {
                    partner_code: item.partner_code,
                    partner_id: item.partner_id,
                  },
                })
              "
            >
              mdi-account-outline
            </v-icon>
            <v-icon
              small
              :title="`${entityLabel} Branches`"
              color="success"
              class="mr-2"
              @click="
                $router.push({
                  name: 'Branch Summary',
                  query: { parent_partner_id: item.partner_id },
                })
              "
            >
              mdi-domain
            </v-icon>
            <v-icon
              small
              :title="`${entityLabel} Banks`"
              color="primary"
              class="mr-2"
              @click="
                $router.push({
                  name: 'partnerBank Summary',
                  query: {
                    parent_partner_id: item.partner_id,
                    name: item.partner_name,
                  },
                })
              "
            >
              mdi-bank
            </v-icon>
            <v-icon
              small
              color="primary"
              class="mr-2"
              @click="deleteItem(item)"
            >
              mdi-trash-can-outline
            </v-icon>
          </div>
        </template>

        <template v-slot:top>
          <v-divider class="p-0 m-0 primary--text"></v-divider>
          <v-col class="mt-5">
            <v-row>
              <v-col class="mt-1">
                <v-btn
                  depressed
                  small
                  class="text-capitalize me-3 text-decoration-none"
                  color="primary"
                  @click="
                    $router.push({
                      path: '/createAgent',
                      query: {
                        parent_partner_id: $route.query.parent_partner_id,
                        partner_name: $route.query.partner_name,
                        country_cd: $route.query.country_cd,
                        partner_type_code: $route.query.partner_type_code,
                      },
                    })
                  "
                  ><v-icon small>mdi-content-save-plus-outline</v-icon>Add
                  {{ entityLabel }}</v-btn
                >
                <v-btn
                  depressed
                  @click="downloadExcelsheet"
                  color="primary"
                  small
                  ><v-icon small>mdi-file-excel-outline</v-icon>Export
                </v-btn>
              </v-col>
              <v-col></v-col>
            </v-row>
            <v-row>
              <v-col></v-col>
              <v-col cols="12" md="4"
                ><v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Type here to filter the table data."
                  hide-details
                  class="me-4 mb-2"
                  dense
                  clearable
                ></v-text-field
              ></v-col>
            </v-row>
          </v-col>
        </template>
        <!-- <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">More info about {{ item.name }}</td>
        </template> -->
      </v-data-table>
      <v-dialog persistent v-model="dialogDelete" width="500">
        <v-card>
          <v-card-title class="border border-bottom">Delete</v-card-title>
          <v-card-text class="h5 py-3"
            >Are you sure you want to delete this prameter?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="deleteItemConfirm"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn depressed small color="primary" outlined @click="closeDelete"
              ><v-icon>mdi-close</v-icon></v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="showBlockDialog" width="500">
        <v-card>
          <v-card-title class="border border-bottom"
            >Update {{ entityLabel }} Status</v-card-title
          >
          <v-card-text class="h5 py-3"
            >{{ entityLabel }} status is {{ isActive ? "Active" : "Blocked" }}.
            Are you sure you want to {{ title_text }}
            {{ entityLabel }}?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="confirmBlock(isActive ? false : true)"
            >
              {{ title_text }}<v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="showBlockDialog = false"
            >
              Close<v-icon>mdi-close</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import alerts from "@/mixins/alerts";
import partnerService from "@/services/partnerService/partnerService.js";
export default {
  mixins: [alerts],
  name: "Agent Summary",
  data() {
    return {
      // expanded: [],
      isCorridor: false,
      search: "",
      dialogDelete: false,
      showUnblockDialog: false,
      showBlockDialog: false,
      isActive: null,
      blockId: null,
      loader: false,
      title: "",
      title_text: "",
      parent_partner_id: null,
      partnerSummary: [],
      bankPage() {
        this.$router.push({ name: "Bank List" });
      },
      Branchname() {
        this.$router.push({ name: "Partner Branch" });
      },
      Payoutcommission() {
        this.$router.push({ name: "Payout Commission" });
      },
    };
  },
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  computed: {
    entityLabel() {
      return !this.isCorridor ? "Channel" : "Corridor";
    },
    pageTitle() {
      return `Remittance ${this.entityLabel}`;
    },
    dessertHeaders() {
      return [
        {
          text: `${this.entityLabel} Id`,
          align: "start",
          sortable: false,
          value: "partner_id",
          groupable: false,
        },
        {
          text: `${this.entityLabel} Name`,
          value: "partner_name",
          groupable: false,
        },
        {
          text: `${this.entityLabel} Code`,
          value: "partner_code",
          groupable: false,
        },
        {
          text: `${this.entityLabel} Type`,
          value: "partner_type_data.value",
          groupable: false,
        },
        { text: "Contact Person", value: "contact_person", groupable: false },
        { text: "Country", value: "company_country_code", groupable: false },
        { text: "Currency", value: "local_currency", groupable: false },
        { text: "Status", value: "status", groupable: false },
        {
          text: "Action",
          value: "action",
          sortable: false,
          width: 200,
          groupable: false,
        },
      ];
    },
  },
  mounted() {
    console.log(this.$route.query);
    this.isCorridor =
      String(this.$route.query.partner_type_code) === "3" ? false : true;
    this.parent_partner_id = this.$route.query.parent_partner_id;
    if (this.$route.query.parent_partner_id) {
      this.getAllPartnerAgents();
    } else {
      // this.getpartnersummary();
    }
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },
    async downloadExcelsheet() {
      if (this.partnerSummary) {
        this.exportToExcel(
          this.dessertHeaders,
          this.partnerSummary,
          `${this.entityLabel} Summary`,
        );
      }
    },
    async getAllPartnerAgents() {
      this.loader = true;
      try {
        const responseData = await partnerService.getpartnerAgentCompany(
          this.parent_partner_id,
        );
        if (responseData.data.status_code == 200) {
          this.partnerSummary = responseData.data.data;
          this.stoploader();
        }
        //  else if(responseData.data.status_code == 401){
        //   this.returnNewToken();
        //   this.getAllBranchesById();
        // }
        else {
          this.showAlertError("Failed" + responseData.data.message);
          this.loader = false;
        }
        console.log("Agent summary", responseData);
      } catch (e) {
        console.log(e);
        this.showAlertError("Fetch data Failed : Something went wrong");
        this.loader = false;
      }
    },
    deleteItem(item) {
      console.log("item", item);
      this.dialogDelete = true;
      this.deleteId = item.partner_id;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
        this.deleteId = "";
      });
    },
    openBlockDialog(item) {
      this.title_text = item.status ? "Block" : "Unblock";
      this.showBlockDialog = true;
      this.isActive = item.status;
      this.blockId = item.partner_id;
    },
    async confirmBlock(active_status) {
      this.showBlockDialog = false;
      this.loader = true;
      try {
        const responseData = await partnerService.blockPartner(
          active_status,
          this.blockId,
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess("Status is Updated : Success");
          this.getAllPartnerAgents();
          this.loader = false;
        } else {
          this.showAlertError("Failed:" + responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (e) {
        console.log(e);
        this.loader = false;
        this.showAlertError("Status update failed: Something went wrong");
      }

      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    async deleteItemConfirm() {
      this.loader = true;
      try {
        const responseData = await partnerService.deletePartner(this.deleteId);
        this.response = responseData;
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getAllPartnerAgents();
          this.stoploader();
        } else {
          this.showAlertError("Failed:" + responseData.data.message);
          this.loader = false;
        }
      } catch (e) {
        console.log(e);
        this.loader = false;
        this.showAlertError("One or more parameter is invalid or missing!");
      }

      this.closeDelete();
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
</style>
